'use es6';

import Immutable from 'immutable';
import * as DashboardActionTypes from '../actions/ActionTypes';
import { DEFAULT_PAGE_SIZE, LOCALSTORAGE_PAGE_SIZE_KEY } from '../Constants';
const getDefaultPageSize = () => {
  try {
    return parseInt(localStorage.getItem(LOCALSTORAGE_PAGE_SIZE_KEY), 10) || DEFAULT_PAGE_SIZE;
  } catch (e) {
    return DEFAULT_PAGE_SIZE;
  }
};
const defaultState = Immutable.Map({
  pageSize: getDefaultPageSize()
});
export default function FileUsage(state = defaultState, {
  type,
  pageSize
}) {
  switch (type) {
    case DashboardActionTypes.SET_PAGE_SIZE:
      try {
        localStorage.setItem(LOCALSTORAGE_PAGE_SIZE_KEY, pageSize);
      } catch (e) {
        console.error('failed to set local storage', e);
      }
      return state.merge({
        pageSize
      });
    default:
      return state;
  }
}